<template>
  <div>
    <v-form>
      <v-container>
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="editado.resultado"
              rounded
              filled
              dense
              background-color="primary"
              color="secondary"
              label="Resultado"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="editado.observaciones"
              rounded
              filled
              dense
              background-color="primary"
              color="secondary"
              label="Observaciones"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-date-picker
              v-model="editado.fechaVigenciaEvaluacionC3"
              locale="es"
              color="secondary"
              no-title
              full-width
            ></v-date-picker>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
    <v-btn color="secondary" class="primary--text px-8 col-12 justify-center" :loading="loading" @click="guardar">
      Editar registro
    </v-btn>
  </div>
</template>

<script>
import DateAdapter from '@src/utils/DateAdapter'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { NotificationFactory, NOTIFICATION_TYPES } from '@src/modules/notificaciones/domain/NotificationFactory'
import Notificacion from '@src/modules/notificaciones/domain/Notificacion'
import moment from 'moment'

export default {
  props: {
    resultadoC3: {
      type: Object,
      required: true,
    },
    idPersonal: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      editado: { ...this.resultadoC3 },
      loading: false,
    }
  },
  computed: {
    ...mapGetters('personal', {
      personal: 'getPersonalSingle',
    }),
  },
  watch: {
    resultadoC3: {
      handler(val) {
        let fecha = null
        if (val.fechaVigenciaEvaluacionC3) {
          try {
            const fechaNormalizada = val.fechaVigenciaEvaluacionC3.replace('a. m.', 'AM').replace('p. m.', 'PM')
            fecha = moment(fechaNormalizada, 'DD/MM/YYYY hh:mm:ss A').format('YYYY-MM-DD')
          } catch (e) {
            fecha = null
          }
        }
        this.editado = {
          ...val,
          fechaVigenciaEvaluacionC3: fecha,
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    ...mapActions('resultadosPersonalesC3', ['updateResultado']),
    ...mapActions('dialog', ['closeDialog']),
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),
    ...mapActions('notificaciones', ['createNotification']),

    async guardar() {
      this.loading = true

      const fechaFormateada = this.editado.fechaVigenciaEvaluacionC3
        ? moment(this.editado.fechaVigenciaEvaluacionC3, 'YYYY-MM-DD').format('DD/MM/YYYY hh:mm:ss A')
        : null

      await this.updateResultado({
        idPersonal: this.idPersonal,
        idResultado: this.editado.idResultado,
        resultado: {
          resultado: this.editado.resultado,
          fechaVigenciaEvaluacionC3: fechaFormateada,
          observaciones: this.editado.observaciones,
        },
      })

      await this.sendNotification()

      this.loading = false
      this.closeDialog()
    },

    async sendNotification() {
      try {
        const notification = new NotificationFactory(Notificacion).createNotification(
          NOTIFICATION_TYPES.EMISION_RESULTADO_C3,
          {
            responsable: Number(localStorage.getItem('idPersonal')),
            afectado: this.idPersonal,
            nombrePersonal: this.getFullName(this.personal),
            resultado: this.editado.resultado,
            fechaVigencia: new DateAdapter(this.editado.fechaVigenciaEvaluacionC3, 'YYYY-MM-DD').toUiSupportedFormat(),
          }
        )

        await this.createNotification(notification)
      } catch (error) {
        this.SET_SNACKBAR_MESSAGE('Ocurrió un error al notificar emisión de resultados.')
      }
    },
  },
}
</script>
